import { BehaviorSubject, Observable, Observer, Subject, Subscription, asyncScheduler, concatMap, delay, filter, from, map, observeOn, of, share, shareReplay } from 'rxjs';

//queue data
export class QueueDataLeanbot  {
	data: string;
	private messages: Subject<string>;
	// messages: BehaviorSubject<string>;
	// broadcast: Observable<string>;
	// subscriptions: Subscription;
	

	constructor() {
		this.data = "";
		this.messages = new Subject();
		// this.broadcast=this.messages.pipe(shareReplay());
		// this.messages.pipe(shareReplay());
		// this.subscriptions = new Subscription();
		// this.messages.subscribe(data=>{
		// 	this.broadcast.map(fn=>fn(data));
		// })
		// this.broadcast=this.messages.asObservable();
	}
	subscribe(observerOrNext?: Partial<Observer<string>> | ((value: string) => void)) {
		// this.subscriptions.add(observerOrNext)
		// this.subscriptions.
		// debugger;
		var lastData="";
		var lastTime=performance.now();
		return this.messages
		// .pipe(
		// 	concatMap((data:string)=>of(data).pipe(delay(10),observeOn(asyncScheduler)))
		// )
		.pipe(
			
			filter((data:string)=>{
				// send data every 2 seconds
			  if (data==lastData && performance.now()-lastTime<2000){
				return false;
			  }
			  lastData=data;
			  lastTime=performance.now();
			  return true;
			}),
			// concatMap((data:string)=>of(data).pipe(delay(10),map(()=>data))),
			
		  )
		.subscribe(observerOrNext);
	}


	next(str: string) {
		// from([str]).pipe(delay(10),observeOn(asyncScheduler)).subscribe(data=>{
		this.messages.next(str);
		// })
		// this.messages.next(str);
				
	}

	async removed_get() {
		if (!this.isEmpty() && this.data.match(/\n/)) {
			this.data;
			var lastIndex = this.data.lastIndexOf('\n');
			//console.log("Data Before:"+this.data);
			var strs = this.data.substring(0, lastIndex + 1);
			var result = strs.split('\n');
			this.data = this.data.substring(lastIndex + 1, this.size());
			//console.log("Data after:"+this.data);
			//console.log("Result data=============:");
			//console.log(result);
			return result;
		}
	}
	transform(chunk: any, controller: any) {
	  // Handle incoming chunk
	  this.data += chunk;
	  const lines = this.data.split("\n");
	  this.data = lines.pop();
	  lines.forEach((line) => {
		line=line||"";
		if (line && line !== "") {
			// console.log("Incoming data: ",line);
			this.messages.next(line);
			controller.enqueue(line);
		}
	  });
	}  
	

	// check if the queue is empty
	isEmpty() {
		return this.data.length == 0;
	}

	// the size of the queue
	size() {
		return this.data.length;
	}

	// empty the queue
	clear() {
		this.data = "";
	}
}
